export const log =
  process.env.NODE_ENV === 'production' ? (_arg) => {} : console.log;

export const logError =
  process.env.NODE_ENV === 'production' ? (_arg) => {} : console.error;
